import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>開発ベンダーの真価を引き出すアプリ開発RFP作成のポイント</>,
  alt: '開発ベンダーの真価を引き出すアプリ開発RFP作成のポイント',
  readText: (
    <>
      すぐに使えるテンプレート付！アプリ開発で絶対に失敗できないプロジェクト担当者の方に向けたアドバイスを、この1冊にまとめました
    </>
  ),
  imgLarge: '/images/img/download/rfp/thumbnail_rfp.webp',
  imgCapture: '/images/img/download/rfp/capture_rfp.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      開発における人材不足や開発コストの課題を解決したい経営層・IT部門責任者。特に、複雑な大規模案件に強いRDRA/DDDや、高品質なAPI開発に有効なSDDなど、フレームワークをAI駆動開発と組み合わせ、開発効率のゲームチェンジャーとなる戦略（工期・品質・成功率に圧倒的な差）を求めている方に最適です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '解像度の高い背景・課題・ゴールの書き方',
  secondHalf2: '機能ではなくユーザーストーリーでUX/UIの提案を引き出すコツ',
  secondHalf3: '見積もりブレやトラブルを防ぐAPI連携・データ責任の明確化',
  secondHalf4: 'RFP作成前に社内で必ずやっておくべき「3つの準備事項」',
}

const DownloadAIDrivenDevelopment: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'd18024e2-1ec7-44b5-9dd6-032f286b868e', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadAIDrivenDevelopment
